<template>
      <v-card style="margin-left:20px; margin-right:20px;margin-top:20px;">
          <v-card-title >
            <b class="prfont">Product List</b>
          </v-card-title>

          <v-row>
         <v-col md="3" v-for="i in data">
          <v-card style="margin:8px;">
            <div style="padding-top:0px;">
              <!-- <v-img style="margin:10px;"
            height="100"
            width="300"
            src="https://cdn.vuetifyjs.com/images/cards/store.jpg"
              ></v-img>-->
              <v-img :src="'https://api.inguzsales.in/u/' +i.photos[0]" height="156" width="auto" />
            </div>
            <!-- <v-img :src="'https://picsum.photos/300/300?random=1'+i.photo1" /> -->
            <v-card-title primary-title></v-card-title>
            <v-card-text>
              <div>
                <span style="font-size:20px;font-weight:500;color:black;">
                  <strong>{{i.productname}}</strong>
                </span>
                <star-rating style=""
                  v-bind:increment="1"
                  v-bind:star-size="14"
                  active-color="#ff4e00"
                  :read-only="true"
                  v-bind:rating="Math.floor(Math.random() * (5 - 1) + 1)"
                  required
                ></star-rating>
              </div>
              <v-flex md12>
                <v-row>
                  <v-col>
                    <span style="font-size:20px;color:black;">
                      <strong>₹{{i.price}}</strong>
                    </span>
                  </v-col>
                  <v-col>
                    <div v-if="i.instock">(In Stock)</div>
                    <div v-else>(Out of Stock)</div>
                  </v-col>
                </v-row>
              </v-flex>
              <span style="font-size:18px;font-weight:300;color:black;">
                <span>{{i.description}}</span>
                <!-- <br /> -->
              </span>
           
                
             
              <!-- <br /> -->

              <v-flex md12>
                <router-link :to="'/Product/' +i._id">
                      <v-btn  color="#ff4e00" dark block>Details</v-btn>
                    </router-link>
                <v-row>
                  <v-col align="center">
                    
                  </v-col>
                </v-row>
              </v-flex>
            </v-card-text>
          </v-card>
        </v-col>
          </v-row>
        </v-card>
</template><script>
import StarRating from "vue-star-rating";
import axios from "axios";


export default {
  props: ["id"],
  components: {
 
    StarRating,
    
  },
  data() {
    return {
      data: [],
      items: [
        { title: "Product List", icon: "mdi-view-dashboard" },
        { title: "Pending Product List", icon: "mdi-image" },
        { title: "View Products", icon: "mdi-help-box" }
      ],
      right: null,
      product: {
        name: null,
        price: null,
        desc: null,
        instock: null,
        seller: null,
        id: null,
        status: null
      }
    };
  },
  beforeMount() {
    this.getproducts();
  },
  methods: {
   getproducts() {
      axios({
        method: "GET",
        url: "/product/all/"
      }).then(Response => {
        this.data = Response.data.data;
       
          var temp = [];
          var tempid = [];
          for (var i = 0; i < this.data.length; i++) {
           
            var tyid = this.data[i]._id;
            temp.push(ty);
            tempid.push(tyid);
          }
          
          this.did = tempid;
          this.visible = false;
        
        this.photos = Response.data.data.photos;

        var tempflag = [];
        for (var i = 0; i < this.photos.length; i++) {
          var tyimg = {
            src: "https://api.inguzsales.in/u/" + this.photos[i],
            // src: $Image_URL + this.regions[i].flag,
            id: this.photos[i]
          };
          tempflag.push(tyimg);
        }
        this.dataImages = tempflag;
      });
    },
  }
};
</script>
<style scoped>
.prfont {
  font-family: "Montserrat";
}
</style>